import LTG_UI_ScreenShootMediator from "../Mediator/LTG_UI_ScreenShootMediator";
/**
 * -分享视频-
 * @param camera 截图用相机
 * @param onClosed 关闭事件
 */
export class LTG_Com_ShareVideoData {
    constructor() {
        this.camera = null;
        /**
         * code: int 0 未分享, 1 已分享
         */
        this.onClosed = null;
    }
    Send() {
        LTG_UI_ScreenShootMediator.instance.Show(this);
        return 0;
    }
}
